<template>
  <div>
    <b-row>
      <h2>{{ $t("scheduler.schedulingForm") }}</h2>
      <success-fade-alert ref="fadeAlertSuccess" :msg="alert.success" />
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </b-row>

    <scheduler :task="scheduler" :modelstate="modelstate" :readonly="!canEdit">
    </scheduler>

    <scheduler-due-date
      :dueDate.sync="scheduler.schedulerDueDate"
    ></scheduler-due-date>

    <div class="mt-4">
      <b-row>
        <b-col sm="12" md="8">
          <!-- <h4>Formulário agendar</h4> -->
          <b-form-group label="Formulário agendar" label-for="input-form-name">
            <b-form-input
              id="input-form-name"
              type="text"
              v-model="form.nome"
              readonly
            >
            </b-form-input>
          </b-form-group>

          <form-scheduler-field
            :field="fieldSearchKey"
            :field-id="1"
            :readonly="!canEdit"
            :values-to-schedule="scheduler.valuesToSchedule"
            @parentForceUpdate="$forceUpdate()"
          >
          </form-scheduler-field>
        </b-col>
      </b-row>
    </div>

    <div class="mt-2">
      <b-button
        class="button"
        size="sm"
        @click="save"
        :disabled="isButtonScheduleDisabled"
      >
        Agendar formulário
      </b-button>

      <router-link class="desktop-buttons ml-2" :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </div>

    <!-- <div class="mt-4">{{ canEdit }}</div> -->
    <!-- <div class="mt-4">fieldSearchKey: {{ fieldSearchKey }}</div> -->
    <!-- <div class="mt-4">form: {{ form }}</div> -->
    <!-- <div class="mt-4">{{ scheduler }}</div> -->
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "FormScheduler",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    FormSchedulerField: () =>
      import("@/components_rms/checklist/scheduler/FormSchedulerField.vue"),
    Scheduler: () => import("@/components_rms/scheduler/Scheduler.vue"),
    SchedulerDueDate: () =>
      import("@/components_rms/checklist/scheduler/SchedulerDueDate.vue"),
  },
  props: {
    formId: {
      type: String,
      default: null,
      description: "FormId",
    },
    schedulerId: {
      type: String,
      default: null,
      description: "SchedulerId",
    },
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "Agendamento efetuado com sucesso",
      },
      form: {},
      fieldSearchKey: {},
      scheduler: {
        id: 0,
        active: true,
        repeat: false,
        intervalType: "H",
        intervalRange: 0,
        isInUse: false,
        dateDayBegin: "",
        dateDayEnd: "",
        eventHourStart: "",
        eventHourEnd: "",
        description: "",
        formId: 0,
        profileId: null,
        userId: null,
        fieldSearchKeyId: 0,
        valuesToSchedule: [],
        schedulerDueDate: {
          schedulerId: 0,
          dueDateIntervalType: 0,
          dueDateIntervalRange: 0,
          schedulerNotifies: [],
        },
      },
      submitted: false,
      modelstate: {},
    };
  },
  created() {
    if (this.schedulerId) {
      this.loadDataScheduler(this.schedulerId).then(() => {
        this.loadDataForm(this.scheduler.formId).then(() => {
          this.scheduler.fieldSearchKeyId = this.fieldSearchKey.id;
        });
      });
    } else {
      this.loadDataForm(this.formId).then(() => {
        this.newScheduler();
      });
    }
  },
  computed: {
    canEdit() {
      return !this.isButtonScheduleDisabled;
    },
    getUrlBackToList() {
      return "/checklist/schedules/";
    },
    isButtonScheduleDisabled() {
      if (!this.scheduler) {
        return true;
      }
      if (this.scheduler.isInUse) {
        return true;
      }
      if (!this.scheduler.active) {
        return true;
      }
      if (this.submitted) {
        return true;
      }
      return false;
    },
  },
  methods: {
    getFormSearchKeyField() {
      // Get all active fields to apply on a searchKey select component
      var fields = [];
      if (this.form) {
        if (this.form.campos) {
          fields = this.form.campos.filter(
            (campo) => campo.nome != "" && campo.ativo
          );
        }
      }

      // Define default searchKey if this information is null
      if (fields.length > 0) {
        let fieldsFiltred = fields.filter((campo) => campo.searchKey == true);
        if (fieldsFiltred.length > 0) {
          return fieldsFiltred[0];
        } else {
          return fields[0];
        }
      }
      return null;
    },
    async loadDataForm(formId) {
      if (formId) {
        let r = await this.$apiChecklist
          .get("/form/getdetailed/" + formId.toString())
          .then((response) => {
            this.form = response.data.data;
            this.fieldSearchKey = this.getFormSearchKeyField();
          })
          .catch((error) => {
            this.form = {};
            this.fieldSearchKey = this.getFormSearchKeyField();
            this.scheduler.fieldSearchKeyId = 0;
            this.scheduler.valuesToSchedule = [];

            console.log("Error to load data on EditForm");
            console.log(error);
            console.log(error.response.data.errors);

            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
            }
          });
      }
    },
    async loadDataScheduler(schedulerId) {
      if (schedulerId) {
        let r = await this.$apiChecklist
          .get("/schedulers/get/" + schedulerId.toString())
          .then((response) => {
            let scheduler = response.data.data;
            scheduler.dateDayBegin = scheduler.dateDayBegin.split("T")[0];
            scheduler.dateDayEnd = scheduler.dateDayEnd.split("T")[0];
            this.scheduler = scheduler;
          })
          .catch((error) => {
            this.form = {};
            this.fieldSearchKey = this.getFormSearchKeyField();
            this.scheduler.fieldSearchKeyId = 0;
            this.scheduler.valuesToSchedule = [];

            console.log("Error to load data on EditForm");
            console.log(error);
            console.log(error.response.data.errors);

            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
            }
          });
      }
    },
    newScheduler() {
      this.scheduler.fieldSearchKeyId = 0;
      this.scheduler.valuesToSchedule = [];

      if (this.fieldSearchKey) {
        this.scheduler.fieldSearchKeyId = this.fieldSearchKey.id;

        if (this.fieldSearchKey.tipo == 7) {
          if (this.fieldSearchKey.valores) {
            this.fieldSearchKey.valores
              .filter((v) => v.ativo)
              .forEach((v) => {
                this.scheduler.valuesToSchedule.push({
                  schedule: false,
                  // valueId: v.id,
                  value: v.valor,
                });
              });
          }
        } else {
          this.scheduler.valuesToSchedule.push({
            schedule: true,
            value: "",
          });
        }
      }

      this.scheduler.formId = parseInt(this.formId);
    },
    save() {
      if (!this.saveValidation()) return;

      this.submitted = true;
      this.scheduler.intervalRange = parseInt(this.scheduler.intervalRange);
      if (this.scheduler.dateDayBegin == "") this.scheduler.dateDayBegin = null;
      if (this.scheduler.dateDayEnd == "") this.scheduler.dateDayEnd = null;

      this.$apiChecklist
        .post("/schedulers/save", this.scheduler)
        .then((response) => {
          console.log(response);
          this.scheduler.id = response.data.data.id;
          this.$refs.fadeAlertSuccess.show();
          this.submitted = false;
          this.modelstate = {};
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = "Verifique os dados informados";
              this.$refs.fadeAlertDanger.show();
            } else {
              this.alert.error = error.response.data.errors;
              this.$refs.fadeAlertDanger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.fadeAlertDanger.show();
          }
        });
    },
    saveValidation() {
      if (this.fieldSearchKey.tipo == 7) {
        let checkedCount = 0;
        for (let value of this.scheduler.valuesToSchedule) {
          if (value.schedule) {
            checkedCount++;
          }
        }
        if (checkedCount == 0) {
          this.alert.error = "Marque ao menos 1 valor para ser agendado";
          this.$refs.fadeAlertDanger.show();
          return false;
        }
      }
      console.log("Tudo certo na validação");
      return true;
    },
  },
};
</script>